import { render, staticRenderFns } from "./component-hr.vue?vue&type=template&id=6d5bd696&scoped=true&"
import script from "./component-hr.vue?vue&type=script&lang=js&"
export * from "./component-hr.vue?vue&type=script&lang=js&"
import style0 from "./component-hr.vue?vue&type=style&index=0&id=6d5bd696&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d5bd696",
  null
  
)

export default component.exports